/**
 * Presentation labels.
 *
 * Kept apart from `schemas.ts` because these are strings the UI shows, not wire
 * contracts — and because keeping them free of the zod import lets the whole
 * presentation-facing half of this package be consumed without pulling a
 * validation library into a bundle that only needs to render a word.
 */
export const USER_ROLE_LABELS = {
    admin: 'Admin',
    dispatcher: 'Dispatcher',
    tech: 'Technician',
};
export const PAYMENT_METHOD_LABELS = {
    cash: 'Cash',
    check: 'Check',
    card: 'Card',
    ach: 'Bank transfer',
    other: 'Other',
};
export const JOB_PRIORITY_LABELS = {
    low: 'Low',
    normal: 'Normal',
    high: 'High',
    emergency: 'Emergency',
};
export const ESTIMATE_STATUS_LABELS = {
    draft: 'Draft',
    sent: 'Sent',
    approved: 'Approved',
    declined: 'Declined',
    expired: 'Expired',
};
export const INVOICE_STATUS_LABELS = {
    draft: 'Draft',
    sent: 'Sent',
    paid: 'Paid',
    void: 'Void',
};
//# sourceMappingURL=labels.js.map